export const salesTaxReportMapping = (item: any) => ({
  Tax: `${item.salesTaxName} ${item.rate}%`,
  SalesSubjectToTax: item.salesSubjectToTax,
  TaxAmountOnSales: item.taxAmountOnSales,
  PurchasesSubjectToTax: item.purchaseSubjectToTax,
  TaxAmountOnPurchase: item.taxAmountOnPurchase,
  StartingBalance: "",
  LessPaymentToGov: "",
});
